import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/myimage.jpg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  // AiOutlineTwitter,
  // AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              Let Me <span className="purple"> Introduce </span> Myself
            </h1>
            <p className="home-about-body">
              I was born in<i><b className="purple"> Shanghai</b> </i>, completed my Bachelor's degree in Math at the Chinese University of <i><b className="purple">Hong Kong</b></i>
              , did an exchange program at ETH <i><b className="purple">Zurich</b></i>. Now I am pursuing a CS degree at <i><b className="purple">New York</b></i> University.
              <br />
              <br />I am experienced in programming languages including
              <i>
                <b className="purple"> Python, Java, C++, JavaScript</b>
              </i>
              , and SQL dialects including
              <i>
                <b className="purple"> SQLite, PostgreSQL, and MySQL</b>.
              </i>
              <br />
              {/* <br />
              My field of Interest's are building new &nbsp;
              <i>
                <b className="purple">...placeholder </b> and
                also in areas related to{" "}
                <b className="purple">
                  ....placeholder
                </b>
              </i>
              <br /> */}
              <br />
              Whenever possible, I also apply my passion for developing products
              with<i> <b className="purple">Node.js</b> </i>and
              <i>
                <b className="purple"> modern Javascript frameworks</b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js ans Next.js</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvatar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>Find Me On</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Zhang-Zecheng"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/zecheng-z/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
